// extracted by mini-css-extract-plugin
module.exports = {"close":"styles_close___9VQE","header":"styles_header__Z2DB4","wrapper":"styles_wrapper__2RBcK","content":"styles_content___70oM","container":"styles_container__MNa03"};